import type { IconName } from "@@/shared/icon-name";
import type { Translatable} from "@@/shared/translations/translation";
import { translation } from "@@/shared/translations/translation";

const headerPageBlockThemes = ["default"] as const;
const headerPageBlockThemesMeta: Record<
    (typeof headerPageBlockThemes)[number],
    {
        iconName: IconName;
        title: Translatable;
        description: Translatable;
    }
> = {
    default: {
        iconName: "fa-palette",
        title: translation({
            sv: "Standard",
            en: "Default",
        }),
        description: translation({
            sv: "Generellt standardtema",
            en: "General default theme",
        }),
    },
};

type HeaderPageBlockTheme = (typeof headerPageBlockThemes)[number];

export { headerPageBlockThemes, headerPageBlockThemesMeta };
export type { HeaderPageBlockTheme };
